export const productPanelId = 'sgs-product-panel';
